module.exports = __webpack_public_path__ + "e096d2434886fc411c3d1fab921de2a6.gif";